import React from 'react'
import DeleteIcon from './icons/DeleteIcon'
import { Color, Colors } from '../styles/Colors';
import styled from 'styled-components';

const Button = styled.button`
    background: none; 
    border: none; 
    background-color: ${({$theme}) => (($theme === 'darkBlue') ?  Color(Colors.white) : Color(Colors.blue))};  
    width: 36px; 
    height: 36px; 
    border-radius: 4px; 

    & > svg {
        fill: ${({$theme}) => (($theme === 'darkBlue') ?  Color(Colors.blue) : Color(Colors.white))};
    }
            
    
    &:hover {
        background-color: ${({$theme}) => ($theme === 'darkBlue' ?  Color(Colors.lightBlue) : Color(Colors.white))}; 
        
        & > svg  {
            fill: ${({$theme}) => (($theme === 'darkBlue') ?  Color(Colors.white) : Color(Colors.blue))};
        }
    }
`; 

const DeleteInputBtn = ({ item, setItem, index, theme }) => {
    const handleDeleteInput = () => {
        const deleteInput = item.document_links.filter((_, i) => i !== index)
        setItem({ ...item, document_links: deleteInput })
    }

    return (
        <Button type='button' onClick={handleDeleteInput} $theme={theme}>
            <DeleteIcon
                height='24px'
                width='24px'
            />
        </Button>
    )
}

export default DeleteInputBtn